import { Box, IconButton, DialogTitle as MuiDialogTitle, Typography } from '@mui/material'

import { XCloseIcon } from '@/components/ui/icons'

import { useDialog } from './dialog-context'

interface Props {
  title: string
  subtitle?: string | null
  // Extra content (status chips, a version switcher, etc.) rendered inline before the close button.
  action?: React.ReactNode
}

export function DialogTitle({ title, subtitle, action }: Props) {
  const onClose = useDialog((s) => s.onClose)

  return (
    <MuiDialogTitle component="div">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
          <Box>
            <Typography variant="h6">{title}</Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ alignSelf: 'flex-start' }}>
          <XCloseIcon sx={{ color: 'text.disabled' }} />
        </IconButton>
      </Box>
    </MuiDialogTitle>
  )
}
